import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { FaSearch, FaHome, FaPencilRuler, FaHammer, FaTree } from 'react-icons/fa';
import axios from 'axios';
import { API_BASE_URL } from '../../config';
import './DirectoryHub.css';
import Header from './components/Header';
import Footer from './components/Footer';

const DirectoryHub = () => {
  const [loading, setLoading] = useState(true);
  const [groupedAz, setGroupedAz] = useState({});
  const [sortedLetters, setSortedLetters] = useState([]);

  useEffect(() => {
    const fetchCategories = async () => {
      try {
        const response = await axios.get(`${API_BASE_URL}/api/directory/categories`);
        groupCategories(response.data);
      } catch (error) {
        console.error("Error fetching directory categories", error);
      } finally {
        setLoading(false);
      }
    };
    fetchCategories();
  }, []);

  const groupCategories = (data) => {
    const groups = data.reduce((acc, cat) => {
      const letter = cat.name.charAt(0).toUpperCase();
      if (!acc[letter]) {
        acc[letter] = [];
      }
      acc[letter].push(cat);
      return acc;
    }, {});

    setGroupedAz(groups);
    setSortedLetters(Object.keys(groups).sort());
  };
  
  // Data Structure: Grouping your DB categories logically
  const categories = {
    "Planning & Consultants": [
      { name: "Architects", slug: "architects" },
      { name: "Building Certifiers", slug: "certifiers" },
      { name: "Quantity Surveyors", slug: "quantity-surveyors" },
      { name: "Structural Engineers", slug: "structural-engineers" },
      { name: "Conveyancers", slug: "conveyancers" },
      { name: "Buyer's Agents", slug: "buyers-agents" }
    ],
    "Structural & Exterior": [
      { name: "Builders", slug: "builders" },
      { name: "Bricklayers", slug: "bricklayers" },
      { name: "Concreters", slug: "concreters" },
      { name: "Roofing", slug: "roofers" },
      { name: "Demolition", slug: "demolition" }
    ],
    "Interiors & Systems": [
      { name: "Electricians", slug: "electricians" },
      { name: "Plumbers", slug: "plumbers" },
      { name: "Air Conditioning (HVAC)", slug: "aircon" },
      { name: "Painters", slug: "painters" },
      { name: "Cabinet Makers", slug: "cabinet-makers" },
      { name: "Tilers", slug: "tilers" }
    ],
    "Outdoor & Landscaping": [
      { name: "Landscapers", slug: "landscapers" },
      { name: "Fencing", slug: "fencing" },
      { name: "Pool Builders", slug: "pool-builders" },
      { name: "Arborists", slug: "arborists" }
    ]
  };

  return (
    <>
    <Header />
    <div className="directory-page">
      
      {/* 1. HERO SEARCH (Reused component usually) */}
      <section className="dir-hero">
        <h1>Australia’s Construction Directory</h1>
        <p>Find local professionals, trades, and suppliers for your next project.</p>
        <div className="dir-search-bar">
          <FaSearch className="search-icon"/>
          <input type="text" placeholder="Search for a service (e.g. Surveyor)..." />
          <button>Search</button>
        </div>
      </section>

      {/* 2. POPULAR TILES (The 80/20 Rule - 80% of clicks go here) */}
      <section className="dir-container">
        <h2>Most Popular</h2>
        <div className="popular-grid">
           <Link to="/directory/builders" className="pop-card">
              <FaHome size={30} />
              <span>Builders</span>
           </Link>
           <Link to="/directory/architects" className="pop-card">
              <FaPencilRuler size={30} />
              <span>Architects</span>
           </Link>
           <Link to="/directory/electricians" className="pop-card">
              <FaHammer size={30} />
              <span>Electricians</span>
           </Link>
           <Link to="/directory/landscapers" className="pop-card">
              <FaTree size={30} />
              <span>Landscapers</span>
           </Link>
        </div>
      </section>

      {/* 3. CATEGORIZED LISTS (The Logic) */}
      <section className="dir-container">
        <div className="category-layout">
          {Object.entries(categories).map(([groupName, items]) => (
            <div key={groupName} className="category-group">
              <h3>{groupName}</h3>
              <ul>
                {items.map((cat) => (
                  <li key={cat.slug}>
                    <Link to={`/directory/${cat.slug}`}>{cat.name}</Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </section>

      {/* 4. A-Z FOOTNOTE (SEO Catch-all) */}
      <section className="dir-container az-section">
        <h3>Don't see what you need?</h3>
        <p>
          <Link to="/directory/all">Browse A-Z Index</Link> or <Link to="/contact-support">Contact Support</Link> for help finding a specialist.
        </p>
      </section>

    </div>
    <Footer />
    </>
  );
};

export default DirectoryHub;
